export function getAppClient(flag) {
  const ua = navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    if (!flag) {
      return window['wx']['miniProgram']
    } else {
      return 'wx.miniProgram'
    }
  } else if (ua.match(/AlipayClient/i) == 'alipayclient') {
    if (!flag) {
      return window['my']
    } else {
      return 'my'
    }
  } else {
    return ''
  }
}

